<script lang="ts" setup>
    import '../../../css/choice.css';
    import { computed } from 'vue';

    const props = defineProps<{
        appointmentId: number
    }>();

    const cancelCommentUrl = computed<string>(() => `/officemd/screens/CommentCancel.asp?appointment_id=${props.appointmentId}`);
</script>

<template>
    <iframe :src="cancelCommentUrl" title="Cancel Comment" :style="{'overflow-y': 'hidden', 'overflow-x': 'hidden', 'width': '100%', 'height': '500px'}"></iframe>
</template>

